import React from 'react';
import Box from '@mui/material/Box';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import { DiamondIcon } from 'src/components/SvgIcons';
import { useCreditStatus } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/hooks/useContentGenerate';
import SlSkeleton from 'src/components/BeaconV2Components/SlSkeleton/SlSkeleton';
import { formatMoney } from 'src/utils/stringFormatting';
import colors from 'src/utils/colors';

/**
 * Credits quick link component for Generation/Projects tabs.
 * Shows credits balance and links to the credits page.
 */
const CreditsQuickLink = () => {
  const { creditBalance, isLoading, isError } = useCreditStatus();

  return (
    <Flex gap={8} alignItems="center">
      <SlButton
        variant="titleExtraSmall"
        buttonSx={{
          padding: 0,
          height: 'fit-content',
          minWidth: 'unset'
        }}
        textSx={{
          '&:hover': {
            textUnderlineOffset: '2px',
            textDecoration: 'underline'
          }
        }}
        onClick={() => {
          window.open('https://advisor.stackline.com/?view=credits', '_blank');
        }}
        startIcon={<DiamondIcon style={{ width: '16px', height: '16px', marginRight: '8px' }} />}
      >
        Credits
      </SlButton>
      {isLoading && <SlSkeleton variant="rectangular" width={60} height={20} sx={{ borderRadius: '2px' }} />}
      {/* {isLoading ? (
        <SlSkeleton variant="rectangular" width={60} height={20} sx={{ borderRadius: '2px' }} />
      ) : (
        <Box
          sx={{
            padding: '4px 8px',
            backgroundColor: colors.pastelGreen,
            color: colors.darkGreen,
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: 500
          }}
        >
          {isError ? 'Error' : formatMoney(creditBalance, '')}
        </Box>
      )} */}
    </Flex>
  );
};

export default CreditsQuickLink;
